export const configProject = {
  colorPrimary: "rgba(48,48,48,0.9)",
  colorLink: "rgba(48,48,48,0.9)",
  colorMenuBackground: "rgba(48,48,48,0.9)",
  colorTextMenu: "white",
  colorTextMenuSelected: "rgba(3,3,3,0.9)",
  colorBgHeader: "rgba(48,48,48,0.9)",
};
